import Button from "./Button";

export default class SoundButton extends Button {
    private _muteCallback: () => any;
    private _muteCallbackContext: any;
    private _muted = false;
    constructor(
        scene: Phaser.Scene,
        x: number,
        y: number,
        texture: string,
        muteCallback?: (muted?: boolean) => any,
        muteCallbackContext?: CallbackContext
    ) {
        super(scene, x, y, texture, null, () => {
            this._muted = !this._muted;
            scene.sound.mute = this._muted;
            this.onMuted(this._muted);
        });

        this._muted = scene.sound.mute;
        this._muteCallback = muteCallback;
        this._muteCallbackContext = muteCallbackContext;
    }

    private onMuted(muted: boolean): void {
        this._muteCallback?.bind(this._muteCallbackContext)(muted);
    }

    updateMute(mute: boolean): void {
        this._muted = mute;
    }
}
